import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType } from "../../siteManagement/sheet";
import { EventType } from "../../siteManagement/eventManager";
import { PageTitleProps } from "../core/components/pageTitle";
import { AssemblyGroup } from "./editAssemblyGroup";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";
export default class PartsApp extends React.Component<PartsAppProps, any> {
    private _lockId: number;
    common = new AppHelper();
    currentUrl: string = null;
    _translations: {};
    csGridOptions: {};
    setTabTitle = true;
    showObsoleteUnit: boolean = false;


    constructor(props: PartsAppProps) {
        super(props);
        this.showObsoleteUnit = false;
        this.common.enableHooks = true;
        this.common.init(this);
        this._translations = props.metadata.additional.objects[0].data;
        this.props.context.CSGrid = this.csGridOptions;
        if (props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(() => {
                this.releaseLock();
            });
        }
        this._setEvents()
    }


    private _showObsoleteUnit = () => {
        this.showObsoleteUnit = Helper.isNullOrEmpty(this.props.entity.UnitId) && !Helper.isNullOrEmpty(this.props.entity.Einheit);
        this.setState({})
    }

    private _setEvents = () => {
        $(window).on("partsValueChanged", (e, d) => {
            this._updateEntity(d.context, d.t.value);
        });
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            switch (data.command) {
                case "assemblyGroupChange":
                    this.handleFieldChange({ model: "entity.AssemblyGroup" }, data.assemblyGroup)
                    break;
            }
        })
    }

    private _updateEntity = (context: string, value: string) => {
        let newEntity = this.props.entity;

        if ((context == "bezeichnung") && (value != this.props.entity.Bezeichnung)) {
            newEntity.Bezeichnung = value;
            Helper.updateEntity(this.props.entity, newEntity);
            this.common.setEntityDirtyState(true);
        } else if ((context == "einheit") && (value != this.props.entity.Einheit)) {
            newEntity.Einheit = value;
            Helper.updateEntity(this.props.entity, newEntity);
            this.common.setEntityDirtyState(true);
        } else if ((context == "langtext") && (value != this.props.entity.Langtext)) {
            newEntity.Langtext = value;
            Helper.updateEntity(this.props.entity, newEntity);
            this.common.setEntityDirtyState(true);
        }

    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass<EntityParts>>("Parts/Save", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        if (this.props.entity.IsNew) {

                            if (Helper.hasValue(result.AdditionalData.ArtNr)) {
                                this.props.entity.ArtNr = result.AdditionalData.ArtNr;
                                this.props.entity.AssemblyGroup = result.Data.AssemblyGroup;
                            }
                            General.Functions.HistoryState.replaceState("Parts/Edit?id=" + this.props.entity.ArtNr);
                        }
                        this.props.entity.IsNew = false;
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    this.setState({});
                });
        }
    }

    remove = () => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOK => {
            if (isOK) {
                HTTPService.post<JsonResultClass>('parts/delete?id=' + this.props.entity.ArtNr)
                    .then(result => {
                        if (result.Code === 0) {
                            this.props.entity.RecordRight.CanWrite = false;
                            this.setState({});
                            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                            if (this.props.isWindow) {
                                const sheet = General.Sheet.Manager.getTopMostVisibleSheet();
                                sheet.hide();
                            } else {
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/Parts";
                                }, 1000);
                            }

                            NotificationHelper.showSuccessMessage(result.Message);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }




    releaseLock = () => {
        if (this._lockId != undefined) {
            clearInterval(this._lockId);
            Helper.releaseLock(this.props.entity.IsId, "MATART");
            this._lockId = undefined;
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        let assemblyGroup = this.props.entity.AssemblyGroup;
        switch (field.model) {
            case "entity.TranslatedNames":
                assemblyGroup.Name = this.searchTranslation(value);
                this.handleFieldChange({ model: "entity.AssemblyGroup" }, assemblyGroup)
                break;
            case "entity.Artikelnummer":
                assemblyGroup.Artikelnummer = value;
                this.handleFieldChange({ model: "entity.AssemblyGroup" }, assemblyGroup)
                break;
            case "entity.TranslatedUnits":
                assemblyGroup.Unit = this.searchTranslation(value);
                this.handleFieldChange({ model: "entity.AssemblyGroup" }, assemblyGroup)
                break;
            case "entity.UnitId":
                if (Helper.hasValue(dataItem) && !Helper.isNullOrEmpty(dataItem.Name)) {
                    const tu = this.props.entity.TranslatedUnits;
                    const index = tu.findIndex(f => f.Key === Config.user.languageId);
                    if (index > -1) {
                        tu[index].Value = dataItem.Name;
                    } else {
                        tu.push({ Key: Config.user.languageId, Value: dataItem.Name })
                    }
                    this.handleFieldChange({ model: "entity.TranslatedUnits" }, tu)
                }
                break;

        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, this._showObsoleteUnit);
    }

    private searchTranslation = (v: { Key, Value }[]) => {
        let result = "";
        const languages = [Config.user.languageId, 1, 0];
        for (let i = 0; i < languages.length; i++) {
            let item = v.find(f => f.Key === languages[i]);
            if (Helper.hasValue(item) && !Helper.isNullOrEmpty(item.Value)) {
                result = item.Value;
                break;
            }
        }
        return result;
    }

    componentDidMount() {
        if (this.props.entity.RecordRight.CanWrite && Helper.hasValue(this.props.entity.IsId) && !this.props.entity.IsNew) {
            this._lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "MATART", 10000);
        }
        this._showObsoleteUnit();
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.Artikelnummer,
            locked: Helper.hasValue(this.props.entity.LockMessage) && this.props.entity.LockMessage.trim() !== "",
            lockInfo: this.props.entity.LockMessage
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }

}

export interface PartsAppPropsContext extends Context {
    CSGrid?: {};
    allocationsGrid?: {};
    openingHoursGrid?: {};
}

export interface PartsAppProps extends AppBaseProps {
    entity: EntityParts;
    context: PartsAppPropsContext;
}

export interface EntityParts extends Entity {
    ArtNr: number;
    Artikelnummer: string;
    Bezeichnung: string;
    Einheit: string,
    Langtext: string,
    EkPreis: number,
    Preis: number;
    Zolltarifid: number,
    Grpnr: number;
    IsId?: number;
    LockMessage?: string;
    AssemblyGroup: AssemblyGroup;
    UnitId: string;
    TranslatedUnits?: KeyValuePair<number, string>[];
}